import { render, staticRenderFns } from "./UserCouponForm.vue?vue&type=template&id=2c339eb6"
import script from "./UserCouponForm.vue?vue&type=script&lang=js"
export * from "./UserCouponForm.vue?vue&type=script&lang=js"
import style0 from "./UserCouponForm.vue?vue&type=style&index=0&id=2c339eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports